import React from 'react';
import PropTypes from 'prop-types';

import { OptionalElementClickTracker } from '../../../analytics/cohesion';
import Button from '../../Shared/Button';

const CTASection = ({
  title,
  description,
  buttonText,
  buttonVariant = 'secondary',
  imageSrc,
  imageAlt = 'cta-image',
  backgroundImage,
  overlayImage,
  backgroundStyle,
  loginUrl,
  className = '',
  contentClassName = '',
  imageClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  buttonClassName = 'w-full md:w-50',
  onClick,
  trackingConfig = null,
}) => {
  return (
    <div
      className={`relative flex flex-col md:flex-row ${backgroundStyle ? 'items-top' : 'items-center'} md:justify-between px-6 py-12 md:px-28 md:py-0 gap-12 md:min-h-[439px] ${className}`}
      style={backgroundStyle || undefined}
    >
      {!backgroundStyle && backgroundImage && (
        <img
          src={backgroundImage}
          alt="background"
          className="absolute w-full h-full md:min-h-[439px] top-0 left-0 right-0 z-10"
        />
      )}
      {!backgroundStyle && overlayImage && (
        <img
          src={overlayImage}
          alt="overlay"
          className="absolute w-full h-full md:min-h-[439px] top-0 left-0 right-0 z-10"
        />
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={imageAlt}
          className={`w-full md:w-[545px] md:min-h-[335px] z-20 ${imageClassName}`}
        />
      )}
      <div
        className={`z-20 flex flex-col items-start gap-5 flex-1 shrink-0 text-center md:text-left ${contentClassName}`}
      >
        <h2
          className={`text-2xl md:text-[32px] leading-[36px] md:leading-[45px] font-semibold text-white ${titleClassName}`}
        >
          {title}
        </h2>
        <div
          className={`text-base leading-6 font-normal font-mark-ot text-white ${descriptionClassName}`}
        >
          {description}
        </div>
        <div className="w-full flex flex-col flex-row sm:justify-center md:justify-start items-center gap-5 flex-wrap">
          <OptionalElementClickTracker trackingConfig={trackingConfig}>
            <Button
              variant={buttonVariant}
              size="medium"
              className={buttonClassName}
              onClick={onClick}
            >
              {buttonText}
            </Button>
          </OptionalElementClickTracker>
          {loginUrl && (
            <p className="text-white text-sm font-extralight leading-5">
              Already signed up?
              <a
                href={loginUrl}
                className="text-white text-sm font-semibold underline leading-6 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent rounded"
              >
                {` Log in`}
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

CTASection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonVariant: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  backgroundImage: PropTypes.string,
  overlayImage: PropTypes.string,
  backgroundStyle: PropTypes.object,
  loginUrl: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func,
  trackingConfig: PropTypes.shape({
    actionOutcome: PropTypes.string,
    webElement: PropTypes.shape({
      elementType: PropTypes.string,
      location: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

export default CTASection;
